import { type ReactNode, createContext, useContext, useMemo } from 'react'

/**
 * How the flow is branded, supplied by the host app. Separate from identity:
 * this follows the host's agreement with Fun, not who the user is.
 */
export interface FunkitBranding {
  /** The host's `hideAttribution` config, defaulted to false here. */
  hideAttribution: boolean
}

// The design shows the mark; a host without the provider gets the default.
const BRANDED: FunkitBranding = { hideAttribution: false }

const FunkitBrandingContext = createContext<FunkitBranding>(BRANDED)

export function FunkitBrandingProvider({
  hideAttribution = false,
  children,
}: {
  hideAttribution?: boolean
  children: ReactNode
}) {
  const branding = useMemo(() => ({ hideAttribution }), [hideAttribution])
  return (
    <FunkitBrandingContext.Provider value={branding}>
      {children}
    </FunkitBrandingContext.Provider>
  )
}

export function useFunkitBranding(): FunkitBranding {
  return useContext(FunkitBrandingContext)
}
